var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { UserPermissions, UserType } from "healthex-common/user.dtos";
import { computed, observable } from "mobx";
import { findMatchingNamedRouteParent } from "./RoutingUIManager";
import { NamedRoutes } from "./NamedRoutes";
import { NOT_LOADED } from "../Infra/RemoteData";
import { filterFalse, willNeverHappen } from "healthex-common/utils";
export class HeaderViewModelDesktop {
    constructor(container) {
        this.patientInvitationDialogOpen = false;
        this.inviteUsersDialogOpen = false;
        this.environment = container.environment;
        this.authManager = container.authManager;
        this.appUIManager = container.appUIManager;
        this.routingUIManager = container.routingUIManager;
        this.welcomeUserUIManager = container.welcomeUserUIManager;
        this.patientInvitationUIManager = container.patientInvitationUIManager;
        this.organizationsManager = container.organizationsManager;
    }
    get organizationLogoUrl() {
        var _a, _b;
        return ((_a = this.authManager.orgLogoUrl) !== null && _a !== void 0 ? _a : (this.welcomeUserUIManager.organization !== NOT_LOADED && ((_b = this.welcomeUserUIManager.organization) === null || _b === void 0 ? void 0 : _b.logoUrl)));
    }
    get organizationName() {
        return this.authManager.orgName;
    }
    get userForAvatar() {
        return this.authManager.userForAvatar;
    }
    get isLoggedIn() {
        return this.authManager.isLoggedIn;
    }
    get isEmbeddedProvider() {
        return this.authManager.isEmbeddedProvider;
    }
    get showAdminTab() {
        return (this.authManager.permissions.includes(UserPermissions.ORG_ADMIN) ||
            this.authManager.permissions.includes(UserPermissions.RESEARCH_ADMIN));
    }
    get headerTabs() {
        if (this.authManager.userType === null)
            return [];
        if (this.authManager.userType === UserType.PATIENT || this.authManager.userType === UserType.PATIENT_READ_ONLY) {
            throw new Error("Should never reach this flow, patients are mobile only");
        }
        else if (this.authManager.userType === UserType.SCREENSHOT_USER) {
            return [];
        }
        else if (this.authManager.userType === UserType.EXTERNAL_RESEARCHER) {
            const admin = this.authManager.permissions.includes(UserPermissions.ORG_ADMIN);
            return filterFalse([{ page: "PROJECTS", label: "Home" }, admin && { page: "ADMIN", label: "Admin" }]);
        }
        else if (this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION) {
            const anyAdmin = this.authManager.permissions.includes(UserPermissions.ORG_ADMIN) ||
                this.authManager.permissions.includes(UserPermissions.RESEARCH_ADMIN);
            const numberOfPermissions = this.authManager.permissions.length;
            const isProvider = this.authManager.permissions.includes(UserPermissions.PROVIDER);
            const isResearcher = this.authManager.permissions.includes(UserPermissions.RESEARCHER);
            const onlyHasProviderPermission = isProvider && numberOfPermissions === 1;
            if (isProvider) {
                if (onlyHasProviderPermission) {
                    return [
                        { page: "PATIENTS", label: "Home" },
                        { page: "PROJECTS", label: "Projects" },
                        { page: "HEALTHCARE_ORG_ANALYTICS", label: "Analytics" },
                    ];
                }
                else if (anyAdmin) {
                    if (isResearcher) {
                        return [
                            { page: "HEALTHCARE_ORG_ANALYTICS", label: "Home" },
                            { page: "PROJECTS", label: "Projects" },
                            { page: "PATIENTS", label: "Patients" },
                            { page: "ADMIN", label: "Admin" },
                        ];
                    }
                    else {
                        return [
                            { page: "HEALTHCARE_ORG_ANALYTICS", label: "Home" },
                            { page: "PATIENTS", label: "Patients" },
                            { page: "PROJECTS", label: "Projects" },
                            { page: "ADMIN", label: "Admin" },
                        ];
                    }
                }
                else if (this.authManager.organizationIsLive === false) {
                    return [];
                }
                else if (isResearcher) {
                    return [
                        { page: "PROJECTS", label: "Home" },
                        { page: "PATIENTS", label: "Patients" },
                        { page: "HEALTHCARE_ORG_ANALYTICS", label: "Analytics" },
                    ];
                }
                return [];
            }
            else if (anyAdmin) {
                return [
                    { page: "HEALTHCARE_ORG_ANALYTICS", label: "Home" },
                    { page: "PROJECTS", label: "Projects" },
                    { page: "ADMIN", label: "Admin" },
                ];
            }
            else if (this.authManager.organizationIsLive === false) {
                return [];
            }
            else {
                return [
                    { page: "PROJECTS", label: "Home" },
                    { page: "HEALTHCARE_ORG_ANALYTICS", label: "Analytics" },
                ];
            }
        }
        else if (this.authManager.userType === UserType.SERVICE_PROVIDER) {
            return [
                { page: "HEALTHCARE_ORG_ANALYTICS", label: "Home" },
                { page: "ADMIN", label: "Admin" },
                { page: "GLOBAL_ADMIN", label: "Global Admin" },
            ];
        }
        else {
            return willNeverHappen(this.authManager.userType);
        }
    }
    get showHeaderTabs() {
        if (this.isEmbeddedProvider)
            return false;
        const noTabsRoutes = [
            NamedRoutes.WELCOME,
            NamedRoutes.WELCOME_ORG,
            NamedRoutes.WELCOME_ORG_USER_DETAILS,
            NamedRoutes.WELCOME_CUSTOMIZE_ORG_DETAILS,
            NamedRoutes.WELCOME_ORG_USER_INVITE,
        ];
        return !findMatchingNamedRouteParent(this.routingUIManager.currentRoute, noTabsRoutes) && this.headerTabs.length > 1;
    }
    get currentPage() {
        return this.appUIManager.currentPage;
    }
    navigateToPage(page) {
        this.appUIManager.navigateToPage(page);
    }
    async navigateToLoginPage() {
        this.routingUIManager.navigateTo(NamedRoutes.LOGIN_AS_ORG_USER);
    }
    navigateToHome() {
        if (this.isEmbeddedProvider)
            return;
        const homepage = this.appUIManager.homepage;
        if (homepage === null)
            return;
        this.appUIManager.navigateToPage(homepage);
    }
    async logout() {
        await this.appUIManager.logout();
    }
    get showGlobalAdminTab() {
        return this.authManager.permissions.includes(UserPermissions.GLOBAL_PROVISIONING);
    }
    get showPatientInviteButton() {
        if (this.isEmbeddedProvider)
            return false;
        return this.authManager.userType === UserType.HEALTHCARE_ORGANIZATION && this.authManager.organizationIsLive;
    }
    get showAskAIButton() {
        if (this.isEmbeddedProvider)
            return false;
        return true;
    }
    get showOpenFullAppButton() {
        if (this.isEmbeddedProvider)
            return true;
        return false;
    }
    get showAvatarOrLogin() {
        if (this.isEmbeddedProvider)
            return false;
        return true;
    }
    get patientInvitationLink() {
        return this.patientInvitationUIManager.invitationLink;
    }
    async copyPatientInvitationLink() {
        await this.patientInvitationUIManager.copyInvitationLink();
    }
    async showPatientInvitationDialog() {
        this.patientInvitationDialogOpen = true;
    }
    async onPatientInvitationDialogChoice(choice) {
        if (choice) {
            await this.copyPatientInvitationLink();
        }
        else {
            this.patientInvitationDialogOpen = false;
        }
    }
    inviteUsers() {
        this.inviteUsersDialogOpen = true;
    }
    async launchFullApp() {
        const shortLivedToken = await this.authManager.getShortLivedTokenForAppLaunch();
        const launchUrl = `${this.environment.WEBAPP_BASE_URL}/#/smart-full-launch/${shortLivedToken}`;
        window.open(launchUrl);
    }
    async inviteUsersDone() {
        await this.organizationsManager.waitForReloadOrganizations();
        this.inviteUsersDialogOpen = false;
    }
    navigateToAIAssistant() {
        this.routingUIManager.navigateTo(NamedRoutes.AI_ASSISTANT);
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], HeaderViewModelDesktop.prototype, "patientInvitationDialogOpen", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], HeaderViewModelDesktop.prototype, "inviteUsersDialogOpen", void 0);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "organizationLogoUrl", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "organizationName", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "userForAvatar", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "isLoggedIn", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "isEmbeddedProvider", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "showAdminTab", null);
__decorate([
    computed,
    __metadata("design:type", Array),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "headerTabs", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "showHeaderTabs", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "currentPage", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "showGlobalAdminTab", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "showPatientInviteButton", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "showAskAIButton", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "showOpenFullAppButton", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "showAvatarOrLogin", null);
__decorate([
    computed,
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [])
], HeaderViewModelDesktop.prototype, "patientInvitationLink", null);
